export const warningTypeMap = {
  ESTAirFilterBlocked: {
    zh: "空滤堵塞",
    en: "Est Air Filter Blocked",
    path: "/warning/EST_AIR_FILTER_BLOCKED",
    code: "EST_AIR_FILTER_BLOCKED"
  },
  ESTAirInletTemperature: {
    zh: "进气高温",
    en: "Est Air Inlet Temperature",
    path: "/warning/EST_AIR_INLET_TEMPERATURE",
    code: "EST_AIR_INLET_TEMPERATURE"
  },
  ESTCoolingWaterBreak: {
    zh: "冷却水断开",
    en: "Est Cooling Water Break",
    path: "/warning/EST_COOLING_WATER_BREAK",
    code: "EST_COOLING_WATER_BREAK"
  },
  ESTElectronicFanOverload: {
    zh: "电控风机过载",
    en: "Est Electronic Fan Overload",
    path: "/warning/EST_ELECTRONIC_FAN_OVERLOAD",
    code: "EST_ELECTRONIC_FAN_OVERLOAD"
  },
  ESTFanBoxOverload: {
    zh: "箱体风机过载",
    en: "Est Fan Box Overload",
    path: "/warning/EST_FAN_BOX_OVERLOAD",
    code: "EST_FAN_BOX_OVERLOAD"
  },
  ESTHighTemperature: {
    zh: "高温预警",
    en: "Est High Temperature",
    path: "/warning/EST_HIGH_TEMPERATURE",
    code: "EST_HIGH_TEMPERATURE"
  },
  ESTInverterHighTemperature: {
    zh: "变频高温",
    en: "Est Inverter High Temperature",
    path: "/warning/EST_INVERTER_HIGH_TEMPERATURE",
    code: "EST_INVERTER_HIGH_TEMPERATURE"
  },
  ESTLowOilInletPressure: {
    zh: "进油压力低",
    en: "Est Low Oli Inlet Pressure",
    path: "/warning/EST_LOW_OIL_INLET_PRESSURE",
    code: "EST_LOW_OIL_INLET_PRESSURE"
  },
  ESTMotorBearingHighTemperature: {
    zh: "电机轴承高温",
    en: "Est Motor Bearing High Temperature",
    path: "/warning/EST_MOTOR_BEARING_HIGH_TEMPERATURE",
    code: "EST_MOTOR_BEARING_HIGH_TEMPERATURE"
  },
  ESTMotorWindingHighTemperature: {
    zh: "电机绕组高温",
    en: "Est Motor Winding High Temperature",
    path: "/warning/EST_MOTOR_WINDING_HIGH_TEMPERATURE",
    code: "EST_MOTOR_WINDING_HIGH_TEMPERATURE"
  },
  ESTOilSeparatorBlocked: {
    zh: "油分堵塞",
    en: "Est Oil Separator Blocked",
    path: "/warning/EST_OIL_SEPARATOR_BLOCKED",
    code: "EST_OIL_SEPARATOR_BLOCKED"
  },
  airFilterBlocked: {
    zh: "空滤堵塞",
    en: "Air Filter Blocked",
    path: "/warning/blocking",
    code: "AIR_FILTER_BLOCKED"
  },
  airInsufficiency: {
    zh: "气量不足",
    en: "Air Insufficiency",
    path: "/warning/air",
    code: "AIR_INSUFFICIENCY"
  },
  dryerForewarn: {
    zh: "冷干机预警",
    en: "Dryer Forewarn",
    path: "/warning/dryerForewarn",
    code: "DRYER_FOREWARN"
  },
  error: {
    zh: "故障历史记录",
    en: "Error List",
    path: "/warning/error",
    code: "ERROR"
  },
  highTemperature: {
    zh: "高温预警",
    en: "High Temperature",
    path: "/warning/heat",
    code: "HIGH_TEMPERATURE"
  },
  inspection: {
    zh: "巡检预警",
    en: "Inspection",
    path: "/warning/inspection",
    code: "INSPECTION"
  },
  inverterHighTemperature: {
    zh: "变频器高温",
    en: "Inverter High Temperature",
    path: "/warning/inverter",
    code: "INVERTER_HIGH_TEMPERATURE"
  },
  loadFrequently: {
    zh: "频繁加卸载",
    en: "Load Frequently",
    path: "/warning/loadFrequently",
    code: "LOAD_FREQUENTLY"
  },
  lowApplyPressure: {
    zh: "应用压力低",
    en: "Low Apply Pressure",
    path: "/warning/LOW_APPLY_PRESSURE",
    code: "LOW_APPLY_PRESSURE"
  },
  lowFrequency: {
    zh: "低温预警",
    en: "Low Frequency",
    path: "/warning/low",
    code: "LOW_FREQUENCY"
  },
  maintain: {
    zh: "维护提醒",
    en: "Maintain",
    path: "/warning/oneyearout",
    code: "MAINTAIN"
  },
  motorHt: {
    zh: "电机温升高",
    en: "Motor heat",
    path: "/warning/motorht",
    code: "MOTOR_HT"
  },
  offline: {
    zh: "离线预警",
    en: "Offline",
    path: "/warning/offline",
    code: "OFFLINE"
  },
  oneYearWithoutMaintain: {
    zh: "一年未保养",
    en: "One year widthout maintain",
    path: "/warning/ONE_YEAR_WITHOUT_MAINTAIN",
    code: "ONE_YEAR_WITHOUT_MAINTAIN"
  },
  outElectricTrend: {
    zh: "电流趋势预警",
    en: "Out Electric Trend",
    path: "/warning/outElectricTrend",
    code: "OUT_ELECTRIC_TREND"
  },
  overCurrent: {
    zh: "过流预警",
    en: "Over current",
    path: "/warning/overflowing",
    code: "OVER_CURRENT"
  },
  overPressure: {
    zh: "超压运行",
    en: "Over Pressure",
    path: "/warning/overPressure",
    code: "OVER_PRESSURE"
  },
  overload: {
    zh: "空压机过载",
    en: "Overload",
    path: "/warning/overload",
    code: "OVERLOAD"
  },
  startFrequently: {
    zh: "频繁启停",
    en: "Start Frequently",
    path: "/warning/startFrequently",
    code: "START_FREQUENTLY"
  }
}